import { useAuth0 } from '@auth0/auth0-react'
import { useCallback } from 'react'

export const useAuthedFetch = (): ((
    input: RequestInfo | URL,
    init?: RequestInit
) => Promise<Response>) => {
    const { getAccessTokenSilently } = useAuth0()

    const authedFetch = useCallback(
        (input: RequestInfo | URL, init?: RequestInit) =>
            getAccessTokenSilently().then((accessToken) => {
                const headers = new Headers(init?.headers)
                headers.set('Authorization', `Bearer ${accessToken}`)
                headers.set('Content-Type', 'application/json')
                return fetch(input, { ...init, headers }).then((response) => {
                    // Centralize non-ok handling: a failed request rejects here
                    // so every caller surfaces it (React Query `isError`, mutation
                    // `onError`) without repeating response.ok checks. Callers that
                    // want to treat non-ok as empty (e.g. getMessages/getState)
                    // catch this instead.
                    if (!response.ok) {
                        throw new Error(
                            `Request failed: ${response.status} ${response.statusText}`
                        )
                    }
                    return response
                })
            }),
        [getAccessTokenSilently]
    )

    return authedFetch
}
